/**
 * Lightweight chip list of the user's most-recently-mastered words.
 * "Here's what you just learned" — a small motivational surface.
 */
import type { RecentMastered } from "../../api";

export default function RecentMasteredChips({
  words,
}: {
  words: RecentMastered[];
}) {
  if (!words || words.length === 0) {
    return (
      <div className="card">
        <div className="mb-2">
          <div className="text-xs text-ink-faint uppercase tracking-[0.14em]">
            recently mastered
          </div>
        </div>
        <div className="text-ink-faint text-sm py-3">
          None yet. Keep chatting — words graduate to "mastered" after a
          handful of successful exposures.
        </div>
      </div>
    );
  }

  return (
    <div className="card">
      <div className="mb-3">
        <div className="text-xs text-ink-faint uppercase tracking-[0.14em]">
          recently mastered
        </div>
        <div className="text-[11px] text-ink-faint mt-0.5">
          words you've locked in, newest first
        </div>
      </div>
      <div className="flex flex-wrap gap-2">
        {words.map((w) => (
          <div
            key={w.word}
            className="inline-flex flex-col gap-0.5 px-3 py-2 rounded-sm bg-paper-warm/40 border border-ink-faint/10"
          >
            <span className="text-sm text-ink font-medium">{w.word}</span>
            {w.gloss ? (
              <span className="text-[10px] text-ink-soft italic">
                {w.gloss}
              </span>
            ) : null}
            <span className="text-[9px] text-ink-faint mt-0.5">
              m{w.mastery} · {w.reps} reps
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
